/* PDP 质保资格弹窗（Check Eligibility）：开合、焦点回位、遮罩关闭、加购按钮转发
   渐进增强：脚本未加载时弹窗不显示（触发按钮无动作），页面其余功能不受影响。
   触发点：①块内的 Check Eligibility 按钮 ②买按钮 block 里的悬浮加购条（W3 联动，位于块外）
   ⇒ 打开动作委托到 document，块外触发点用页面上的第一个弹窗（schema limit: 1）。 */
(function () {
  var ROOT = '[data-vl-pdp-elig]';
  var DIALOG = '[data-vl-pdp-elig-dialog]';
  var OPEN = '[data-vl-pdp-elig-open]';

  /* 2026-10-16 用户指令：**下线**「质保页完成问卷 ⇒ 带 `?vl_warranty_eligibility=1` 到 PDP 即免问卷直接加购」
     的口径 —— PDP 一律走弹窗问卷（原 `hasMarker()` / `toAddToCart()` / `applyBypass()` 已删除）。
     质保页现在自己在结果卡里直接加购（见 `assets/vl-warranty-eligibility.js` 的 applyAtcProperties／startAtcLoading）。 */

  /* ---------- $199 加购按钮的 loading 反馈 ----------
     结果卡的加购按钮带 `form="…"`，位于 `<product-form>` 之外 ⇒ 主题
     `ProductForm.setLoading(true/false)`（bundle.js）只切换表单内部的 `button[type="submit"]`，
     本按钮拿不到任何 loading 态、也不会被 `setDisable()` 禁用（可重复提交）。
     这里复用同一份信号：包装本弹窗自己的 `<product-form>.setLoading`，
     提交开始 → 按钮转圈；主题 AJAX 结束（`setLoading(false)`）→ 复位。
     主题失败分支只 `console.log`、不复位 loading ⇒ 另加超时兜底。 */
  var ATC_LOADING = 'vl-we__btn--loading';
  var ATC_TIMEOUT = 15000; // ms；失败/异常时兜底复位
  var atcBtn = null;
  var atcTimer = null;

  function paintAtc(btn, on) {
    if (!btn) return;
    if (on) btn.classList.add(ATC_LOADING);
    else btn.classList.remove(ATC_LOADING);
    if (on) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
    var spinner = btn.querySelector('[data-vl-we-atc-spinner]');
    if (spinner) {
      if (on) spinner.removeAttribute('hidden');
      else spinner.setAttribute('hidden', '');
    }
  }

  function stopAtcLoading() {
    if (atcTimer) {
      clearTimeout(atcTimer);
      atcTimer = null;
    }
    paintAtc(atcBtn, false);
    atcBtn = null;
  }

  /* 只包装本弹窗自己的 <product-form>（每块一个实例，互不影响）：
     ① loading：把主题信号同步到本按钮；
     ② 加购成功 ⇒ 关闭弹窗。 */
  function bindFormLoading(form) {
    var host = form && form.closest ? form.closest('product-form') : null;
    if (!host || host.vlPdpEligLoadingBound === '1') return;
    host.vlPdpEligLoadingBound = '1';

    // ① loading 信号 ⇒ 本按钮
    if (typeof host.setLoading === 'function') {
      var originalSetLoading = host.setLoading;
      host.setLoading = function (isLoading) {
        originalSetLoading.call(host, isLoading);
        if (isLoading) {
          if (atcBtn) paintAtc(atcBtn, true);
        } else {
          stopAtcLoading();
        }
      };
    }

    // ② 加购成功 ⇒ 关掉弹窗（用户 2026-10-13 指令）
    //    主题 `ProductForm.handleFormSubmit` 走 `this.cartApi.add(config).then(state => …)`，
    //    `CartAPI.add` 原样返回响应文本：`description` 非空＝失败（变体失效/库存等），网络级失败则 reject。
    //    ⇒ 只在真正成功时关窗，失败时保留弹窗让用户改选或重试（与主题 showError 的判据保持一致）。
    var api = host.cartApi;
    if (api && typeof api.add === 'function' && api.vlPdpEligAddBound !== '1') {
      api.vlPdpEligAddBound = '1';
      var originalAdd = api.add;
      api.add = function () {
        return originalAdd.apply(this, arguments).then(function (state) {
          var failed = false;
          try {
            failed = !!(state && JSON.parse(state).description);
          } catch (err) {
            failed = false; // 解析不了就按成功处理（与主题一致：主题只在能解析出 description 时报错）
          }
          if (!failed) setTimeout(closeDialogForAdd, 0); // 让主题先把购物车抽屉打开再关窗
          return state;
        });
      };
    }
  }

  /* 加购成功后的收尾：关掉当前打开的资格弹窗（无弹窗时无动作 ⇒ W5 带参直达/悬浮条路径不受影响） */
  function closeDialogForAdd() {
    var dialog = document.querySelector(DIALOG + '[open]');
    if (dialog) hideDialog(dialog);
  }

  function startAtcLoading(btn, form) {
    atcBtn = btn;
    paintAtc(btn, true);
    if (atcTimer) clearTimeout(atcTimer);
    atcTimer = setTimeout(stopAtcLoading, ATC_TIMEOUT);
    bindFormLoading(form);
  }

  function setScrollLock(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  function showDialog(dialog, trigger) {
    dialog.vlPdpEligTrigger = trigger || null;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    setScrollLock(true);
    var first = dialog.querySelector('select, input, button:not([data-vl-pdp-elig-close])');
    if (first && first.focus) first.focus({ preventScroll: true });
  }

  function hideDialog(dialog) {
    var trigger = dialog.vlPdpEligTrigger;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    setScrollLock(false);
    if (trigger && trigger.focus) trigger.focus({ preventScroll: true });
    dialog.vlPdpEligTrigger = null;
  }

  function init(root) {
    if (root.dataset.vlPdpEligReady === '1') return; // 同页重复渲染时只初始化一次
    root.dataset.vlPdpEligReady = '1';

    var dialog = root.querySelector(DIALOG);
    if (!dialog) return;

    var close = root.querySelector('[data-vl-pdp-elig-close]');
    if (close) {
      close.addEventListener('click', function () {
        hideDialog(dialog);
      });
    }

    // 点遮罩关闭：`<dialog>` 的点击目标是 dialog 自身（面板之外）
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) hideDialog(dialog);
    });

    /* 弹窗内的页内锚点（如 s6 的「View 2-Year* Warranty Policy」→ `#vl-warranty-term-1`）：
       `<dialog>` 打开时页面被锁滚动（documentElement overflow:hidden），此时滚动看不到效果
       ⇒ 在**捕获阶段**先关窗（`hideDialog` 会同步解开滚动锁、并把焦点还给触发按钮），
       同一次点击随后仍会冒泡到共享脚本（`assets/vl-warranty-eligibility.js`）的锚点处理，
       由它完成「让出悬浮条高度的平滑滚动 + 展开目标折叠卡 + 写入 hash」。
       目标锚点不存在时不拦截（保持原样，避免出现「点了却没反应还以为坏了」的假象）。 */
    dialog.addEventListener(
      'click',
      function (event) {
        var link = event.target && event.target.closest ? event.target.closest('a[href^="#"]') : null;
        if (!link) return;
        var hash = link.getAttribute('href');
        if (!hash || hash.length < 2) return;
        if (!document.getElementById(hash.slice(1))) return;
        hideDialog(dialog);
      },
      true
    );

    // 原生关闭（ESC 等）时同步滚动锁与焦点
    dialog.addEventListener('close', function () {
      var trigger = dialog.vlPdpEligTrigger;
      setScrollLock(false);
      if (trigger && trigger.focus) trigger.focus({ preventScroll: true });
      dialog.vlPdpEligTrigger = null;
    });

    // 结果卡里的加购按钮：`form="<隐藏表单 id>"` 显式转成 form.requestSubmit()，
    // 保证走一次标准 submit 事件（主题的 <product-form> 在 submit 上接管 AJAX / 抽屉 / loading）
    dialog.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('button[form]') : null;
      if (!btn) return;
      var form = document.getElementById(btn.getAttribute('form'));
      if (!form) return;
      event.preventDefault();
      // 已在加购中（连点/回车）：忽略重复提交，避免重复加购
      if (btn.classList.contains(ATC_LOADING)) return;
      if (btn.hasAttribute('data-vl-pdp-elig-atc')) startAtcLoading(btn, form);
      if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
      else form.submit();
    });
  }

  /* 打开弹窗（委托）：块内按钮与其所在块的弹窗；块外触发点（悬浮加购条）用页面第一个弹窗 */
  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest(OPEN) : null;
    if (!trigger) return;
    // 带参直达（W5 写入 sessionStorage 标记）时该按钮已被改回原生加购，不再开弹窗
    if (trigger.dataset.vlPdpEligBypass === '1') return;

    var scoped = trigger.closest(ROOT);
    var dialog = (scoped && scoped.querySelector(DIALOG)) || document.querySelector(DIALOG);
    if (!dialog) return;

    event.preventDefault();
    showDialog(dialog, trigger);
  });

  /* 带参直达时的加购转发：块内按钮在弹窗外（`form="<隐藏表单>"`），统一走 requestSubmit，
     保证只触发一次标准 submit 事件（主题 <product-form> 在 submit 上接管 AJAX／抽屉／loading）。
     弹窗内的加购按钮由 dialog 上的监听处理。 */
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('button[form]') : null;
    if (!btn || btn.dataset.vlPdpEligBypass !== '1') return;
    var form = document.getElementById(btn.getAttribute('form'));
    if (!form) return;
    event.preventDefault();
    if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
    else form.submit();
  });

  function boot(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var roots = host.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
    if (host !== document && host.matches && host.matches(ROOT)) init(host);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
